import alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';

const guestConvertHandler = async data => {
  await alooma.UNSAFE_trackAloomaEvent(ALOOMA.EVENT_NAMES.STANDARD_REG, alooma.formRegistrationData(data));
};

export default guestConvertHandler;
